import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class AboutV3 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="ltn__about-us-area pt-115 pb-100 ">
			  <div className="container">
			    <div className="row">
			      <div className="col-lg-6 align-self-center">
			        <div className="about-us-img-wrap about-img-left">
			          <img src={publicUrl+"assets/img/service/service-working.png"} alt="About Us Image" />
			          <div className="about-us-img-info about-us-img-info-2 about-us-img-info-3 d-none">
			            <div className="ltn__video-img ltn__animation-pulse1">
			              <img src={publicUrl+"assets/img/service/service-working.png"} alt="video popup bg image" />
			              {/* <a className="ltn__video-icon-2 ltn__video-icon-2-border---" href="https://www.youtube.com/embed/X7R-q9rsrtU?autoplay=1&showinfo=0" data-rel="lightcase:myCollection">
			                <i className="fa fa-play" />
			              </a> */}
			            </div>
			          </div>
			        </div>
			      </div>
			      <div className="col-lg-6 align-self-center">
			        <div className="about-us-info-wrap">
			          <div className="section-title-area ltn__section-title-2--- mb-30">
			            <h6 className="section-subtitle section-subtitle-2--- ltn__secondary-color">About Us</h6>
			            <h1 className="section-title">Working Flow</h1>
			            <p>We have have a very talented team which will visit the site when work is progress. We will make sure to provide good quality of work.</p>
			          </div>                        
			          <div className="ltn__feature-item ltn__feature-item-3">
			            <div className="ltn__feature-icon" style={{ width: 100, height:100}}>
						  <img src={publicUrl+"assets/img/icons/service-1.png"} alt="video popup bg image" />
			            </div>
			            <div className="ltn__feature-info">
			              {/* <h4><a href="service-details.html">Desgin</a></h4> */}
						  <h4>Desgin</h4>
			              <p>We will desgin the system for your home and consulting service and once deagin is ready in software then only we will start working.</p>
			            </div>
			          </div>
			          <div className="ltn__feature-item ltn__feature-item-3">
					  <div className="ltn__feature-icon" style={{ width: 70, height:70}}>
						  <img src={publicUrl+"assets/img/icons/service-3.png"} alt="video popup bg image" />
			            </div>
			            <div className="ltn__feature-info">
			              {/* <h4><a href="service-details.html">Installation</a></h4> */}
						  <h4>Installation</h4>
			              <p>Once desgin is ready our team will start Installation of each product for automation side of things.</p>
			            </div>
			          </div>
			          <div className="ltn__feature-item ltn__feature-item-3">
					  <div className="ltn__feature-icon" style={{ width: 50, height:50}}>
						  <img src={publicUrl+"assets/img/icons/service-2.png"} alt="video popup bg image" />
			            </div>
			            <div className="ltn__feature-info">
			              {/* <h4><a href="service-details.html">Provide Support</a></h4> */}
						  <h4>Provide Support</h4>
			              <p>We will also provide support and maintance.</p>
			            </div>
			          </div>
			        </div>
			      </div>
			    </div>
			  </div>
			</div>
        }
}

export default AboutV3